import { FeatureName } from "@/config/features";
import { ReactNode } from "react";
import { useFeature } from "@/config/useFeature";

interface FeatureProps {
  flag: FeatureName;
  children: ReactNode;
  fallback?: ReactNode;
}

export default function Feature({
  flag,
  children,
  fallback = null,
}: FeatureProps) {
  return <>{useFeature(flag) ? children : fallback}</>;
}
